import { render, staticRenderFns } from "./SectionSocial.vue?vue&type=template&id=60af3296&scoped=true&"
import script from "./SectionSocial.vue?vue&type=script&lang=js&"
export * from "./SectionSocial.vue?vue&type=script&lang=js&"
import style0 from "./SectionSocial.vue?vue&type=style&index=0&id=60af3296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af3296",
  null
  
)

export default component.exports